import { VscDebugStepOver } from 'react-icons/vsc';
import { FaVolumeUp, FaPalette } from 'react-icons/fa';
import { useSettingsStore } from '../../../store/settingsStore';
import { useThemeStore } from '../../../store/themeStore';
import DirectionSelector from '../fields/DirectionSelector';
import ListItem from '../../common/ListItem';

const ToggleRow: React.FC<{
    icon: React.ReactNode;
    title: string;
    subtitle: string;
    enabled: boolean;
    onToggle: (v: boolean) => void;
}> = ({ icon, title, subtitle, enabled, onToggle }) => {
    const { selectedTheme } = useThemeStore();
    return (
        <ListItem
            icon={icon}
            content={
                <div className="flex w-full items-center justify-between">
                    <div className="flex flex-col">
                        <span className="text-lg">{title}</span>
                        <span className="text-xs opacity-60">{subtitle}</span>
                    </div>
                    <button
                        onClick={() => onToggle(!enabled)}
                        className="relative h-8 w-14 rounded-full transition-colors"
                        style={{
                            backgroundColor: enabled ? selectedTheme.color.point : 'rgba(128,128,128,0.4)',
                        }}
                        aria-label={title}
                    >
                        <span
                            className={`absolute top-1 size-6 rounded-full bg-white transition-transform ${
                                enabled ? 'translate-x-7' : 'translate-x-1'
                            }`}
                        />
                    </button>
                </div>
            }
        />
    );
};

const TimerSettings: React.FC = () => {
    const {
        tickEnabled,
        setTickEnabled,
        voiceEnabled,
        setVoiceEnabled,
        progressColorEnabled,
        setProgressColorEnabled,
    } = useSettingsStore();
    return (
        <div>
            <h3 className="text-lg font-semibold">Timer</h3>
            <div className="mt-6 space-y-4">
                <DirectionSelector />
                <ToggleRow
                    icon={<VscDebugStepOver size={24} className="size-full" />}
                    title="⏱️ Tick Sound"
                    subtitle="Play a soft tick every second"
                    enabled={tickEnabled}
                    onToggle={setTickEnabled}
                />
                <ToggleRow
                    icon={<FaVolumeUp size={22} className="size-full" />}
                    title="🗣️ Voice Announcements"
                    subtitle="Speak each sub-alarm label aloud"
                    enabled={voiceEnabled}
                    onToggle={setVoiceEnabled}
                />
                <ToggleRow
                    icon={<FaPalette size={22} className="size-full" />}
                    title="🌈 Color by Progress"
                    subtitle="Ring shifts green→yellow→red as time runs out"
                    enabled={progressColorEnabled}
                    onToggle={setProgressColorEnabled}
                />
            </div>
        </div>
    );
};

export default TimerSettings;
